<!--Main Container-->
<div class="MainMenu">
	<!--Header-->
	<div class="HeaderCenter">
		<h4>Select a Section:</h4>
	</div>

	<!--Top, Selector-->
	<div class="SemesterSelect">
		<label style="margin: 0">School:</label>
		<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="SchoolID">
            <option value="" style="display:none;"></option>
            <option *ngFor="let o of lstSchool" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
        </select> -->

		<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>

		<label style="margin: 0">Semester:</label>
		<select [disabled]="loading" class="form-control" name="SemesterID" (ngModelChange)="onSemesterChange($event)" [(ngModel)]="SemesterID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSemesters" [ngValue]="o.SemesterID">
				{{ o.Semester }}
			</option>
		</select>
	</div>

	<!--Bottom, Table-->
	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstSection"
			[loading]="loading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedSection"
			dataKey="SectionID"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--CourseNo-->
					<th>
						<p-columnFilter type="text" field="CourseNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--CourseCD-->
					<th>
						<p-columnFilter type="text" field="CourseCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--InstructorDesc-->
					<th>
						<p-columnFilter type="text" field="InstructorDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="CourseNo">Section<p-sortIcon field="CourseNo"></p-sortIcon></th>
					<th pSortableColumn="CourseCD">Description<p-sortIcon field="CourseCD"></p-sortIcon></th>
					<th pSortableColumn="InstructorDesc">Instructor<p-sortIcon field="InstructorDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Section>
				<tr [pSelectableRow]="Section">
					<td *ngFor="let col of cols" style="font-weight: bold">
						{{ Section[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
